module.exports = __webpack_public_path__ + "svg/select-arrow.svg";